window.addEventListener('load', frd_product_color_swatches);

/**
  * Color swatches for products
  * This includes grid items and product pages.
  */
function frd_product_color_swatches() {
  const color_swatches = document.querySelectorAll('ul.ss__results a.swatch');

  if(color_swatches) {
    color_swatches.forEach(color_swatch => {
      color_swatch.addEventListener('mouseover', (event) => {
        let active_color_swatch = document.querySelector('ul.ss__results a.swatch.active');
        let grid_item_img = color_swatch.parentElement.parentElement.querySelector('.productThumb img');
        let color_swatch_img_src = color_swatch.getAttribute('data-hover-image');
  
        grid_item_img.setAttribute('srcset', color_swatch_img_src);
        grid_item_img.setAttribute('src', color_swatch_img_src);
  
        if(active_color_swatch) {
          active_color_swatch.classList.remove('active');
        }
  
        color_swatch.classList.add('active');
      });
    });
  }
}
